import React from 'react';
import './Button.css';

export default function Button({ children, variant = 'primary', type = 'button', ...rest }) {
  return (
    <button type={type} className={`shared-button shared-button--${variant}`} {...rest}>
      {children}
    </button>
  );
}
